
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/wixData/components/collectionsList/actionButtons.scss.css.virtualfile';
        module.exports = {"buttonContainer":"_buttonContainer_rl8r3_7"};